import { render, staticRenderFns } from "./NewAuthorityRule.vue?vue&type=template&id=07d9bc6e&scoped=true&"
import script from "./NewAuthorityRule.vue?vue&type=script&lang=js&"
export * from "./NewAuthorityRule.vue?vue&type=script&lang=js&"
import style0 from "./NewAuthorityRule.vue?vue&type=style&index=0&id=07d9bc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9bc6e",
  null
  
)

export default component.exports